import { AdSlot } from "react-dfp";
import classNames from "classnames";

import styles from "../Advertisement.module.scss";

export const AuthorSidebarAd: React.FC<{ isList?: boolean }> = ({
  isList = true,
}) => {
  const isClientSide = typeof window !== "undefined";
  const isDesktop = isClientSide && window.innerWidth >= 1240;

  return isDesktop ? (
    <div
      className={classNames(
        styles.sidebar,
        styles.author,
        !isList && styles.page
      )}
    >
      <AdSlot
        adUnit={`newoncev3_redaktorzyhalfpage`}
        sizes={[
          [300, 250],
          [300, 50],
          [300, 600],
        ]}
      />
    </div>
  ) : null;
};

export default AuthorSidebarAd;
